module.exports = __webpack_public_path__ + "static/media/Costas.65136f69.png";